module.exports = __webpack_public_path__ + "img/inventario_1.aec708f8.png";